// src/utils/storage.utils.js
// Storage limits in bytes based on subscription type
export const storageLimits = {
    '3': 50 * 1024 * 1024, // Basic: 50MB
    '2': 5 * 1024 * 1024 * 1024, // Premium: 5GB
    '1': 1 * 1024 * 1024 * 1024 // Standard: 1GB
  };
  
  // Format bytes to human-readable size
  export const formatSize = (bytes) => {
    bytes = Number(bytes) || 0;
    
    if (bytes === 0) return '0 B';
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return parseFloat((bytes / Math.pow(1024, i)).toFixed(1)) + ' ' + sizes[i];
  };
  
  // Get maximum storage size based on subscription
  export const getMaxStorageSize = (subscriptionType) => {
    return storageLimits[subscriptionType] || storageLimits['1'];
  };
  
  // Get total used storage across all buckets
  export const getTotalUsedStorage = (storageData) => {
    if (!storageData || !storageData.bucketSizes) return 0;
    return storageData.bucketSizes.reduce((total, bucket) => total + bucket.size, 0);
  };
  
  // Calculate percentage of storage used
  export const getUsedPercentage = (used, total) => {
    return Math.min(Math.round((used / total) * 100), 100);
  };